import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import BlogArticle from "@/pages/blog/sugargoo-spreadsheet-complete-guide/page";
import SugargooReview from "@/pages/blog/sugargoo-review-2026/page";
import ShippingCostGuide from "@/pages/blog/sugargoo-shipping-cost-guide/page";
import CouponGuide from "@/pages/blog/sugargoo-coupon-discount-guide/page";
import WarehouseGuide from "@/pages/blog/sugargoo-warehouse-guide/page";
import IsSugargooLegit from "@/pages/blog/is-sugargoo-legit/page";
import BeginnersGuide from "@/pages/blog/sugargoo-spreadsheet-for-beginners/page";
import WinningProducts from "@/pages/blog/how-to-find-winning-products/page";
import DropshippingGuide from "@/pages/blog/sugargoo-spreadsheet-for-dropshipping/page";
import ChinaShoppingTips from "@/pages/blog/china-shopping-tips/page";
import ShoppingGuide from "@/pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/blog/sugargoo-spreadsheet-complete-guide",
    element: <BlogArticle />,
  },
  {
    path: "/blog/sugargoo-review-2026",
    element: <SugargooReview />,
  },
  {
    path: "/blog/sugargoo-shipping-cost-guide",
    element: <ShippingCostGuide />,
  },
  {
    path: "/blog/sugargoo-coupon-discount-guide",
    element: <CouponGuide />,
  },
  {
    path: "/blog/sugargoo-warehouse-guide",
    element: <WarehouseGuide />,
  },
  {
    path: "/blog/is-sugargoo-legit",
    element: <IsSugargooLegit />,
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-beginners",
    element: <BeginnersGuide />,
  },
  {
    path: "/blog/how-to-find-winning-products",
    element: <WinningProducts />,
  },
  {
    path: "/blog/sugargoo-spreadsheet-for-dropshipping",
    element: <DropshippingGuide />,
  },
  {
    path: "/blog/china-shopping-tips",
    element: <ChinaShoppingTips />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;